import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconAmenitiesWiFiComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5 13a10 10 0 0 1 14 0" fill="none" />
        <path d="M8.5 16.5a5 5 0 0 1 7 0" fill="none" />
        <path d="M2 8.82a15 15 0 0 1 20 0" fill="none" />
        <line fill="none" x1="12" x2="12.01" y1="20" y2="20" />
      </svg>
    </SvgIcon>
  );
};

IconAmenitiesWiFiComponent.displayName = 'IconAmenitiesWiFi';

const IconAmenitiesWiFi = React.memo(IconAmenitiesWiFiComponent);

export default IconAmenitiesWiFi;
